import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';

const ProgramaSelector = ({ value, onChange, required = false, disabled = false, placeholder = 'Selecione um programa', small = false }) => {
  const [programas, setProgramas] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const carregarProgramas = async () => {
      try {
        const cnpj = localStorage.getItem('cnpj');
        const response = await axios.get(`${API_BASE_URL.PROGRAMA}/all`, {
          params: { cnpjAssociacao: cnpj },
          headers: { Authorization: `Bearer ${token}` }
        });
        const ativos = Array.isArray(response.data)
          ? response.data.filter(p => p.situacao === true)
          : [];
        setProgramas(ativos);
      } catch (error) {
        console.error('Erro ao carregar programas:', error);
      } finally {
        setLoading(false);
      }
    };
    carregarProgramas();
  }, [token]);

  if (loading) {
    return <div className="form-control bg-light">Carregando programas...</div>;
  }

  return (
    <select
      className={`form-select${small ? ' form-select-sm' : ''}`}
      value={value || ''}
      onChange={(e) => onChange(parseInt(e.target.value))}
      required={required}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {programas.map(prog => (
        <option key={prog.id} value={prog.id}>
          {prog.descricao}
        </option>
      ))}
    </select>
  );
};

export default ProgramaSelector;
